import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Grid, GridColumn as Column, GridCell, GridNoRecords, GridSortChangeEvent } from '@progress/kendo-react-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

type State = {
    sort: SortDescriptor[];
    schools: School[];
    isLoading: boolean;
}

export interface School {
    SchoolId: number;
    SchoolName: string;
    SchoolAddress: string;
}

class SchoolNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={`/school/${this.props.dataItem.SchoolId}`}>
                    {this.props.dataItem.SchoolName}
                </Link>
            </td>
        );
    }
}

class SchoolAddressCell extends GridCell {
    render() {
        return (
            <td>
                <span>{this.props.dataItem.SchoolAddress}</span>
            </td>
        );
    }
}

class Schools extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            schools: [],
            isLoading: false,
            sort: [{field: "SchoolName", dir: "asc"}],
        };

        this.getSchools = this.getSchools.bind(this)
        this.sortChange = this.sortChange.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        this.getSchools();
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Schools" />
            <div className="row">
                <div className="col">
                    <h1>Schools</h1>
                </div>
                <div className="col">
                    <Link
                        role="button"
                        className="btn btn-primary float-right"
                        to={ '/school/0' }
                    >
                        Add School
                    </Link>
                </div>
            </div>
            {this.state.isLoading && <LoadingPanel />}
            <Grid data={this.state.schools}
                sortable={{
                    allowUnsort: true
                }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
                pageable={{
                    buttonCount: 0,
                    info: true,
                    type: 'numeric',
                    pageSizes: false,
                    previousNext: false
                }}
                skip={0}
                take={this.state.schools.length}
                total={this.state.schools.length}>
                <GridNoRecords>
                    No schools found, you can add new schools <Link style={{ color: '#007bff' }} to='/school/0'>Here</Link>.
                </GridNoRecords>
                <Column field="SchoolName" title="Name" cell={SchoolNameCell} />
                <Column field="SchoolAddress" title="School" cell={SchoolAddressCell} />
            </Grid>
            <br />
        </React.Fragment>;
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            schools: orderBy(this.state.schools, event.sort)
        });
    }

    private getSchools() {
        this.setState({ isLoading: true });
        fetchApi('api/School/List', {}, 'POST')
            .then((schools: School[]) => {
                this.setState({ schools: orderBy(schools, this.state.sort), isLoading: false });
            });
    }
}

export default Schools;
